// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__Z0mfX","perPage10":"Cards_perPage10__8tBjs","perPage20":"Cards_perPage20__5iCak","row":"Cards_row__IeJtr","col-lg-1":"Cards_col-lg-1__gINr-"};